import React, { useEffect, useState } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  PreviewAltCard,
  Row,
} from "../../../components/Component";
import { StepHeader } from "./StepHeader";
import { Form, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { useLocation, useNavigate } from "react-router";
import useLogout from "../../../hooks/useLogout";
import { useFieldArray, useForm } from "react-hook-form";
import { BASE_URL_IMG, DAYS, slotDuration } from "../../../assets/constants";
import classNames from "classnames";
import MyLoader from "../../../MyComp/UI/form/MyLoader";
import MyMobile from "../../../MyComp/UI/form/MyMobile";
import MySelect from "../../../MyComp/UI/form/MySelect";
import MyInput from "../../../MyComp/UI/form/MyInput";
import {
  addOfflineDoctorSlotAPI,
  addOnlineDoctorSlotAPI,
  doctorOfflineSlot,
  doctorOnlineSlot,
} from "../../../api/doctor";
import { createPharmacyMedicineStore, createPharmacyStore, getZipDetailsAPI } from "../../../api/master/indes";
import { transformBack, transformToAvailabilityFormat } from "../../../utils/Utils";
import { toast } from "react-toastify";

import MyTextArea from "../../../MyComp/UI/form/MyTextArea";
import MyButton from "../../../MyComp/UI/form/MyButton";
import ImageUpload from "../../../MyComp/UI/form/ImageUpload";
import { stepFourPharmacyDetails } from "../../../api/dropdown";

const StepFourPharmacy = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const logout = useLogout();
  const doctor = location?.state?.data;
  const [activeTab, setActiveTab] = useState("offline");
  const [activeDay, setActiveDay] = useState("monday");
  const [api, setApi] = useState([]);
  const [loading, setLoading] = useState(true);
  const [startTime, setStartTime] = useState("");
  const doctorId = location?.state?.doctorId || null;
  const [mode, setMode] = useState(location?.state?.mode || "Add");

  const toggle = (tab) => {
    setActiveTab(tab);
  };
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    reset,
    setError,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      agreed: false,
      medical_qualification: null,
      storeTypeDD: [],
      countryDD: [{ value: "India", label: "India" }],
      country: { value: "India", label: "India" },
      stateDD: [],
      cityDD: [],
      paymentModeDD: [
        {
          value: "card",
          label: "Card",
        },
        {
          value: "cash",
          label: "Cash",
        },
        {
          value: "net_banking",
          label: "Net Banking",
        },
        {
          value: "upi",
          label: "UPI",
        },
      ],
      deliveryRadiusDD: [
        {
          value: "1",
          label: "1 KM",
        },
        {
          value: "2",
          label: "2 KM",
        },
        {
          value: "3",
          label: "3 KM",
        },
        {
          value: "4",
          label: "4 KM",
        },
        {
          value: "5",
          label: "5 KM",
        },
        {
          value: "6",
          label: "6 KM",
        },
        {
          value: "7",
          label: "7 KM",
        },
        {
          value: "8",
          label: "8 KM",
        },
        {
          value: "9",
          label: "9 KM",
        },
        {
          value: "10",
          label: "10 KM",
        },
      ],

      store_image: null,
      store_img: null,

      pan_image: null,
      pan_img: null,

      drug_img: null,
      drug_image: null,

      aadhaar_f_image: null,
      aadhaar_f_img: null,

      aadhaar_b_image: null,
      aadhaar_b_img: null,

      catalog_image: null,
      catalog_img: null,

      fssai_image: null,
      fssai_img: null,

      cheque_image: null,
      cheque_img: null,

      objectionKeys: [],
      approvedKeys: [],

      degree: [
        {
          certificate: null,
          certificate_url: null,
        },
      ],
      mode: location?.state?.mode || "Add",
      actionType: null,
    },
  });
  const isLoading = watch("isLoading");
  //time form
  const [imageOpen, setImageOpen] = useState(false);
  const handleImageOpenPreview = (row) => {
    const imageUrl = `${row?.image}`;
    setValue("image_preview", imageUrl);
    setImageOpen(true);
  };

  const onFormSubmit = (data) => {
    console.log(data, "Form Data");
    const formData = new FormData();
    formData.append("pharmacyId", location?.state?.pharmacyId);
    formData.append("name", data.account_holder_name || "");
    formData.append("accountNumber", data.account_no || "");
    formData.append("upiId", data.upi_id || "");
    formData.append("ifscCode", data.ifsc || "");
    formData.append("policy", data.cancellation_policy || "");
    const files = [
      { key: "drug_license", file: data.drug_img, label: "Drug License" },
      // { key: "medical_catalog", file: data.catalog_img, label: "Drug Catalog" },
      { key: "fassai_license", file: data.fssai_img, label: "FSSAI License" },
      { key: "cancelled_check_image", file: data.cheque_img, label: "Cancelled Cheque / Passbook" },
    ];
    for (let f of files) {
      // if (!(f.file instanceof File)) {
      //   toast.error(`${f.label} is required`);
      //   return;
      // }
      formData.append(f.key, f.file);
    }
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }
    if (mode === "Add"|| mode==="Edit") {
      createPharmacyMedicineStore(formData)
        .then((res) => {
          if (res.data.status === true) {
            // toast.success(res.data.message);
            navigate("/pharmacy-list", {
              // state: { mode: "Add", pharmacyId: res.data.data?.pharmacyId },
              state: { mode: mode, pharmacyId:mode==="Add"? res.data.data?.pharmacyId:location.state.pharmacyId },
            });
          } else if (res.data.status === "expired") {
            toast.error(res.data.message);
            logout();
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => toast.error(err?.response?.data?.message));
    }
  };
    useEffect(() => {
      const body = { pharmacyId: location.state.pharmacyId };
      if(mode==="Edit"){
        stepFourDetails(body);
      }
    }, []);
const stepFourDetails = (body) => {
  stepFourPharmacyDetails(body)
    .then((res) => {
      if (res.data.status === true) {
        toast.clearWaitingQueue();
        const data = res.data.data;

        console.log(data, "stepFourDetails");

       
        setValue("account_holder_name", data.name || "");
        setValue("account_no", data.accountNumber || "");
        setValue("upi_id", data.upiId || "");
        setValue("ifsc", data.ifscCode || "");

        setValue(
          "drug_image",
          data?.drug_license ? `${BASE_URL_IMG}${data.drug_license}` : ""
        );
        
        setValue(
          "fssai_image",
          data?.fassai_license ? `${BASE_URL_IMG}${data.fassai_license}` : ""
        );
        
        setValue(
          "cheque_image",
          data?.cancelled_check_image ? `${BASE_URL_IMG}${data.cancelled_check_image}` : ""
        );
        

        setValue("isLoading", false);
      } 
      else if (res.data.status === false) {
        setValue("isLoading", false);
        toast.error(res.data.message);
        toast.clearWaitingQueue();
      } 
      else if (res.data.status === "expired") {
        setValue("isLoading", false);
        toast.error(res.data.message);
        toast.clearWaitingQueue();
        logout();
      }
    })
    .catch((err) => {
      setValue("isLoading", false);
      toast.error(err?.response?.data?.message);
    });
};

  
  return (
    <>
      <Head title={"Pharmacy registration | medicine"} />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Pharmacy Registration"}
              </BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewAltCard>
            <StepHeader current={4} />
            <Form onSubmit={handleSubmit(onFormSubmit)}>
              <Row className=" ">
                <h5 className="my-3">{"Medicine & Bank Documents"}</h5>

                <Col md="4">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Bank Account Holder name"
                    name="account_holder_name"
                    placeholder="Enter bank account holder name"
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col md="4">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Account No"
                    name="account_no"
                    placeholder="Enter bank no"
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col md="4">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="UPI ID"
                    name="upi_id"
                    placeholder="Enter upi id"
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col md="4" className={`mt-2`}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="IFSC Code"
                    name="ifsc"
                    placeholder="Enter ifsc code"
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col md="4" className={`mt-2`}>
                  <ImageUpload
                    getValues={getValues}
                    design={4}
                    id="drug_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"Drug License Image"}
                    errors={errors}
                    register={register}
                    image={"drug_img"}
                    image_url={"drug_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                    validateDoc
                    approve={mode === "Approval" ? true : false}
                    size={2048}
                  />
                </Col>
                {/* <Col md="4">
                <ImageUpload
                  getValues={getValues}
                  design={4}
                  id="catalog_image"
                  watch={watch}
                  trigger={trigger}
                  setError={setError}
                  clearErrors={clearErrors}
                  label={"Drug Catalog"}
                  errors={errors}
                  register={register}
                  image={"catalog_img"}
                  image_url={"catalog_image"}
                  setValue={setValue}
                  // handleImageOpenPreview={handleImageOpenPreview}
                  required
                  validateDoc
                  approve={mode === "Approval" ? true : false}
                  size={2048}
                />
              </Col> */}
                <Col md="4" className={`mt-2`}>
                  <ImageUpload
                    getValues={getValues}
                    design={4}
                    id="fssai_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"FSSAI License (Food)"}
                    errors={errors}
                    register={register}
                    image={"fssai_img"}
                    image_url={"fssai_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                    validateDoc
                    approve={mode === "Approval" ? true : false}
                    size={2048}
                  />
                </Col>
                <Col md="4" className={`mt-2`}>
                  <ImageUpload
                    getValues={getValues}
                    design={4}
                    id="cheque_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"Cancelled Cheque / Bank Passbook"}
                    errors={errors}
                    register={register}
                    image={"cheque_img"}
                    image_url={"cheque_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                    validateDoc
                    approve={mode === "Approval" ? true : false}
                    size={2048}
                  />
                </Col>
                {/* <Col md="12" className={``}>
                <MyTextArea
                  register={register}
                  watch={watch}
                  setValue={setValue}
                  trigger={trigger}
                  errors={errors}
                  title={"Cancellation/Return Policy"}
                  name={"cancellation_policy"}
                  placeholder={"Enter cancellation / return policy"}
                  required
                  // min={5}
                  // max={500}
                  cols={2}
                  row={2}
                  disabled={mode == "Approval"}
                />
              </Col> */}
              </Row>
              {(mode == "Add" || mode == "Edit") && (
                <Row>
                  <Col md="12" className={``}>
                    <div className="form-group d-flex justify-content-end" style={{ marginTop: "31px" }}>
                      <MyButton isLoading={isLoading} mode={mode} />
                    </div>
                  </Col>
                </Row>
              )}
            </Form>
          </PreviewAltCard>
        </Block>
      </Content>
    </>
  );
};

export default StepFourPharmacy;
